module.exports = __webpack_public_path__ + "static/img/ewm.8d6a0cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/sus/ewm.jpg
// module id = KDIn
// module chunks = 40